var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_redefine-all.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_redefine-all.js
// module chunks = 168707334958949